import { Router, NavigationEnd } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import * as $ from 'jquery'
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer-intl',
  templateUrl: './footer-intl.component.html',
  styleUrls: ['./footer-intl.component.scss']
})
export class FooterIntlComponent implements OnInit {
  urls=environment.AppRedirectUrls;
  constructor(public router: Router){}
  ngOnInit(): void {
  }


}
